var _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _rect3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgDisableDirectoryIcon = function SvgDisableDirectoryIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 30,
    viewBox: "0 0 28 30",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0489 17.2955C16.3827 17.2955 18.2746 15.4246 18.2746 13.1167C18.2746 10.8089 16.3827 8.93799 14.0489 8.93799C11.7152 8.93799 9.82324 10.8089 9.82324 13.1167C9.82324 15.4246 11.7152 17.2955 14.0489 17.2955Z",
    fill: "#B5B5C3",
    fillOpacity: 0.3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.031 17.2952C23.5869 17.2952 24.8481 16.0479 24.8481 14.5093C24.8481 12.9708 23.5869 11.7235 22.031 11.7235C20.4751 11.7235 19.2139 12.9708 19.2139 14.5093C19.2139 16.0479 20.4751 17.2952 22.031 17.2952Z",
    fill: "#B5B5C3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06835 17.2952C7.62421 17.2952 8.88548 16.0479 8.88548 14.5093C8.88548 12.9708 7.62421 11.7235 6.06835 11.7235C4.51249 11.7235 3.25122 12.9708 3.25122 14.5093C3.25122 16.0479 4.51249 17.2952 6.06835 17.2952Z",
    fill: "#B5B5C3",
    fillOpacity: 0.3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.45311 19.0149C7.46242 18.2116 6.56469 18.3184 5.41906 18.3184C4.59736 18.3162 3.80841 18.6368 3.2257 19.2097C2.643 19.7827 2.31425 20.561 2.31177 21.3736V26.3165C2.31276 26.6687 2.455 27.0062 2.70728 27.2548C2.95956 27.5034 3.30126 27.6428 3.65742 27.6426C6.86237 27.6426 6.47455 27.7002 6.47455 27.5061C6.47642 24.0034 6.05761 21.4348 8.45311 19.0149Z",
    fill: "#B5B5C3",
    fillOpacity: 0.3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1191 18.3379C13.118 18.1726 11.3779 18.3379 9.87827 19.5646C7.36727 21.5536 7.85087 24.2308 7.85087 27.5069C7.85162 27.9271 8.02074 28.3299 8.32119 28.627C8.62164 28.9241 9.02892 29.0913 9.45382 29.0921C19.1147 29.0921 19.5016 29.4004 20.0725 28.1458C20.2603 27.7215 20.2087 27.8561 20.2087 23.7981C20.2066 22.4228 19.6824 21.0984 18.7398 20.0872C17.7972 19.076 16.505 18.4517 15.1191 18.3379Z",
    fill: "#B5B5C3",
    fillOpacity: 0.3
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6378 18.3182C21.4856 18.3182 20.5935 18.2133 19.6038 19.0147C21.9824 21.4161 21.5805 23.8091 21.5805 27.505C21.5805 27.7 21.2602 27.6415 24.3516 27.6415C24.7206 27.642 25.0747 27.4976 25.3362 27.2401C25.5976 26.9826 25.7451 26.633 25.7461 26.2681V21.3724C25.7433 20.5599 25.4143 19.7816 24.8315 19.2089C24.2486 18.6361 23.4595 18.3158 22.6378 18.3182Z",
    fill: "#B5B5C3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3994 2.58985V6.6763C11.3994 7.54573 12.1108 8.25711 12.9802 8.25711H16.9593L19.1408 10.168C19.457 10.5316 20.0576 10.3103 20.0576 9.83604V8.25711H20.2836C21.153 8.25711 21.8644 7.54573 21.8644 6.6763V2.58985C21.8644 1.72042 21.153 1.00903 20.2836 1.00903H12.9802C12.1108 1.00903 11.3994 1.72042 11.3994 2.58985Z",
    fill: "#B5B5C3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.1443,
    y: 2.7533,
    width: 6.97667,
    height: 0.872083,
    rx: 0.436042,
    fill: "#E9E9ED"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13.1443,
    y: 4.49719,
    width: 1.74417,
    height: 0.872083,
    rx: 0.436042,
    fill: "#E9E9ED"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16.6321,
    y: 4.49719,
    width: 3.48833,
    height: 0.872083,
    rx: 0.436042,
    fill: "#E9E9ED"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDisableDirectoryIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/DisableDirectoryIcon.b923ad11.svg";
export { ForwardRef as ReactComponent };